<template>
  <div class="about bg-light">
    <div class="container space-1">
      <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
        <span class="d-block small font-weight-bold text-cap mb-2">Always improving</span>
        <h2>Solutions rooted in code and design</h2>
      </div>
      <img class="img-fluid" src="/assets/svg/illustrations/ai-creation.svg" alt="Image Description">
    </div>
    <div class="container">
      <!-- Step -->
      <ul class="step step-md step-centered">
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">1</span>
            <div class="step-content">
              <h3>Industry-leading designs</h3>
              <p>Achieve virtually any design and layout from within the one template.</p>
            </div>
          </div>
        </li>

        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">2</span>
            <div class="step-content">
              <h3>Learn from the docs</h3>
              <p>Whether you're a startup or a global enterprise, learn how to integrate with Front.</p>
            </div>
          </div>
        </li>

        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">3</span>
            <div class="step-content">
              <h3>Accelerate your business</h3>
              <p>We help power millions of businesses to built and run smoothly.</p>
            </div>
          </div>
        </li>
      </ul>
      <!-- End Step -->
    </div>
    <div class="container space-2">
      <div class="row justify-content-lg-center">
        <div class="col-md-12">
        </div>
        <div class="col-md-6 col-lg-5 mb-3 mb-md-7">
          <!-- Icon Blocks -->
          <div class="media pr-lg-5">
            <figure class="w-100 max-w-8rem mr-4">
              <img class="img-fluid" src="/assets/svg/icons/icon-9.svg" alt="SVG">
            </figure>
            <div class="media-body">
              <h4>Responsive</h4>
              <p>Front is an incredibly beautiful, fully responsive, and mobile-first projects on the web.</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-6 col-lg-5 mb-3 mb-md-7">
          <!-- Icon Blocks -->
          <div class="media pl-lg-5">
            <figure class="w-100 max-w-8rem mr-4">
              <img class="img-fluid" src="/assets/svg/illustrations/multi-family-house.svg" alt="SVG">
            </figure>
            <div class="media-body">
              <h4>Customizable</h4>
              <p>Front template can be easily customized with its cutting-edge components and features.</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="w-100"></div>

        <div class="col-md-6 col-lg-5 mb-3 mb-md-7 mb-lg-0">
          <!-- Icon Blocks -->
          <div class="media pr-lg-5">
            <figure class="w-100 max-w-8rem mr-4">
              <img class="img-fluid" src="/assets/svg/illustrations/small-house.svg" alt="SVG">
            </figure>
            <div class="media-body">
              <h4>Premium</h4>
              <p>Front is not only for developers but also for designers, and includes a Sketch file.</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>

        <div class="col-md-6 col-lg-5">
          <!-- Icon Blocks -->
          <div class="media pl-lg-5">
            <figure class="w-100 max-w-8rem mr-4">
              <img class="img-fluid" src="/assets/svg/illustrations/flat-house.svg" alt="SVG">
            </figure>
            <div class="media-body">
              <h4>Documentation</h4>
              <p>Every component and plugin is well documented with live examples.</p>
            </div>
          </div>
          <!-- End Icon Blocks -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dismissSecs: 10,
        dismissCountDown: 0,
        showDismissibleAlert: false
      }
    },
    
    methods: {
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      }
    }
  }
</script>
